import CustomModal from './CustomModal';

/** Purchase flows — same shell as CustomModal, wider panel */
export default function PurchaseCustomModal({ active, handleModal, title, children }) {
  return (
    <CustomModal
      active={active}
      handleModal={handleModal}
      title={title}
      size="large"
    >
      {children}
    </CustomModal>
  );
}
